import React, { useEffect } from "react";
import { useLogout } from "../hooks/useLogout";
import {LoadingIcon} from "tds_shared_ui";

//TODO: MOVE TO SHARED UI
const LogoutPage = () => {
    const logout = useLogout();

    useEffect(() => {
        logout().then(() => {});
    }, []);

    return <div><LoadingIcon display={true} size="3x" /></div>;
};

export default LogoutPage;